import {
  FaChartLine,
  FaCheck,
  FaCodeBranch,
  FaExclamationTriangle,
} from "react-icons/fa";

// SidebarIconKey is defined in `types/` to avoid types/ → components/ circularity.
export type { SidebarIconKey } from "../../../../../types/layout/sidebarIcons";

export const sidebarIconMap = {
  checklist: FaCheck,
  integrationPlanning: FaChartLine,
  raid: FaExclamationTriangle,
  decisionsLog: FaCodeBranch,
} as const;
